import { fmtZ, fmtPctile } from './types';

export function AxisStat({
  label, z, pct, regime, color,
}: {
  label: string;
  z: number | null | undefined;
  pct: number | null | undefined;
  regime: string | null | undefined;
  color: 'emerald' | 'sky';
}) {
  const labelColor = color === 'emerald' ? 'text-emerald-300/80' : 'text-sky-300/80';
  const zColor = z == null ? 'text-[#64748b]'
    : z >= 1.5 ? 'text-emerald-400'
    : z >= 0.5 ? 'text-emerald-300'
    : z >= -0.5 ? 'text-[#cbd5e1]'
    : z >= -1.5 ? 'text-amber-300'
    : 'text-red-400';
  return (
    <div>
      <div className={`text-[9px] uppercase tracking-wide ${labelColor}`}>{label}</div>
      <div className="flex items-baseline gap-2">
        <span className={`tabular-nums font-semibold text-[12px] ${zColor}`}>{fmtZ(z)}</span>
        <span className="text-[10px] text-[#94a3b8]">·</span>
        <span className="text-[10px] text-[#cbd5e1] tabular-nums">{fmtPctile(pct)} own hist</span>
      </div>
      {regime && (
        <div className="text-[9px] text-[#64748b] italic mt-0.5 truncate">{regime}</div>
      )}
    </div>
  );
}

export function PillarBar({ label, value, weight }: { label: string; value: number | null; weight: number }) {
  const v = value ?? 0;
  const clipped = Math.max(-3, Math.min(3, v));
  const widthPct = ((clipped + 3) / 6) * 100;
  const color = v >= 1 ? '#22c55e'
    : v >= 0 ? '#94a3b8'
    : v >= -1 ? '#fb923c'
    : '#ef4444';
  return (
    <div className="grid grid-cols-[100px_1fr_60px_50px] gap-2 items-center text-[10px]">
      <span className="text-[#94a3b8]">{label}</span>
      <div className="h-1.5 bg-[#1e293b] rounded-sm overflow-hidden relative">
        <div className="h-full" style={{ width: `${widthPct}%`, backgroundColor: color, opacity: value == null ? 0.2 : 0.8 }} />
        <div className="absolute top-0 bottom-0 w-px bg-[#475569]" style={{ left: '50%' }} />
      </div>
      <span className="tabular-nums text-[#cbd5e1] text-right">{fmtZ(value)}</span>
      <span className="text-[#64748b] text-right tabular-nums">{weight}% wt</span>
    </div>
  );
}
